import type { TenantPublicInfoQuery } from '@/app/api/generated';
import { serviceProfile as jsonServiceProfile } from '@/profile/serviceProfile';
import type { ServiceProfile, MapType } from '@/profile/type';

export const prepareServiceProfile = (
  data: TenantPublicInfoQuery
): ServiceProfile => {
  let renderingResources = data.tenantPublicInfo[0]?.renderingResources;
  if (renderingResources !== undefined) {
    try {
      renderingResources = JSON.parse(renderingResources);
    } catch (error) {
      console.error('renderingResourcesのパースに失敗しました。', error);

      return jsonServiceProfile;
    }

    const mergedMapTypes =
      renderingResources.mapTypes?.map((renderingMapType: MapType) => {
        const base = jsonServiceProfile.mapTypes.find(
          (jsonMapType) => jsonMapType.id === renderingMapType.id
        );

        return base
          ? {
              ...renderingMapType,
              isAdministratorOnly: base.isAdministratorOnly,
            }
          : renderingMapType;
      }) ?? jsonServiceProfile.mapTypes;

    const hasMapConfig = renderingResources.mapConfig != null;
    // NOTE: clusterキーが存在するか（クラスター設定がOFFのときはnullが入るため、undefinedとnullの両方を考慮）
    const hasClusterKey =
      hasMapConfig &&
      Object.prototype.hasOwnProperty.call(
        renderingResources.mapConfig,
        'cluster'
      );

    return {
      ...jsonServiceProfile,
      mapTypes: mergedMapTypes,
      mapConfig: hasMapConfig
        ? {
            ...jsonServiceProfile.mapConfig,
            ...renderingResources.mapConfig,
            initialValue: {
              ...jsonServiceProfile.mapConfig.initialValue,
              ...renderingResources.mapConfig.initialValue,
            },
            cluster: hasClusterKey
              ? renderingResources.mapConfig.cluster
              : jsonServiceProfile.mapConfig.cluster,
          }
        : jsonServiceProfile.mapConfig,
      spot: {
        ...jsonServiceProfile.spot,
        ...renderingResources.spot,
        grouping:
          renderingResources.spot?.grouping != null
            ? renderingResources.spot.grouping
            : jsonServiceProfile.spot?.grouping,
      },
    };
  }

  return jsonServiceProfile;
};
